import {RawPointCloud} from ".";

export class E57PointCloud extends RawPointCloud {
  constructor(pointclouds) {
    super(pointclouds);
  }
}